<template>
    <div>
        <breadcrumb :routerList="[{to:'/agent/ability',title:'经销商能力胜任测评'},{title:'测评审批'}]"/>
<!--      <Breadtabsheader/>-->
        <div class="h-content">

            <div class="h-row h-mrt0">
                <div class="h-rowIn">

                    <div class="h-rowBox">
                        <el-form  ref="form1" :model="f"  :rules="rules">
                            <div class="h-rowCon">
                                <div class="h-pieceIn2">
                                    <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                        <h1>新增经销商能力胜任测评表</h1>
                                    </div>
                                  <div class="h-pieceCon2">
                                    <div class="h-formLine ">

                                      <div class="margin-top el-descriptions">
                                        <div class="el-descriptions__body">
                                          <table class ="meeting-table el-descriptions__table is-bordered ">
                                            <tr>
                                              <th colspan="11" class="my-label el-descriptions-item__cell el-descriptions-item__label ">基础信息</th>
                                            </tr>
                                            <tr>
                                              <th colspan="2" style="width: 15%" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                区    域
                                              </th>
                                              <td colspan="5" style="width: 30%" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.areaName}}
                                              </td>
                                              <th colspan="2" style="width: 15%" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                测评日期
                                              </th>
                                              <td colspan="3" style="width: 30%" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-date-picker
                                                    style="width: 180px;"
                                                    align="center"
                                                    v-model="f.evaluationDate"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    placeholder="选择测评日期">
                                                </el-date-picker>
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                公司名称（全称）
                                              </th>
                                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.agentName}}
                                              </td>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                法人代表
                                              </th>
                                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.legal}}
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                对阵地市实际（个数）
                                              </th>
                                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.againstAreaActualCount}}
                                              </td>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                对阵用户实际（个数）
                                              </th>
                                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.againstUserActualCount}}
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                对阵地市目标（个数）
                                              </th>
                                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.againstAreaTargetCount}}
                                              </td>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                对阵用户目标（个数）
                                              </th>
                                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.againstUserTargetlCount}}
                                              </td>
                                            </tr>
                                            <tr>
                                              <th colspan="11" class="my-label el-descriptions-item__cell el-descriptions-item__label ">业绩测评</th>
                                            </tr>
                                            <tr>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                年实际
                                              </th>
                                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.yearActual}}
                                              </td>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                年目标
                                              </th>
                                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.yearTargetl}}
                                              </td>
                                            </tr>
                                            <tr>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                季度实际
                                              </th>
                                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.quarterActual}}
                                              </td>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                季度目标
                                              </th>
                                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.quarterTargetl}}
                                              </td>
                                            </tr>
                                            <tr>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                年履约率
                                              </th>
                                              <td colspan="5" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.yearLx}}
                                              </td>
                                              <th colspan="2"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                季度履约率
                                              </th>
                                              <td colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                {{f.quarterLx}}
                                              </td>
                                            </tr>
                                            <tr>
                                              <th colspan="11" class="my-label el-descriptions-item__cell el-descriptions-item__label ">测评项目</th>
                                            </tr>
                                            <tr>
                                              <th colspan="2" class="my-label el-descriptions-item__cell el-descriptions-item__label ">测评项目</th>
                                              <th colspan="3" class="my-label el-descriptions-item__cell el-descriptions-item__label ">项目描述</th>
                                              <th colspan="2" class="my-label el-descriptions-item__cell el-descriptions-item__label ">考评细则</th>
                                              <th colspan="1" style="width: 50px" class="my-label el-descriptions-item__cell el-descriptions-item__label ">满分值</th>
                                              <th colspan="1" class="my-label el-descriptions-item__cell el-descriptions-item__label ">实际描述</th>
                                              <th colspan="1" style="width: 100px" class="my-label el-descriptions-item__cell el-descriptions-item__label ">得分</th>
                                              <th colspan="1"  class="my-label el-descriptions-item__cell el-descriptions-item__label ">附件</th>
                                            </tr>
                                            <tr>
                                              <th colspan="7" class="my-label el-descriptions-item__cell el-descriptions-item__label ">综合分值</th>
                                              <th colspan="1" style="width: 100px" class="my-label el-descriptions-item__cell el-descriptions-item__label ">100</th>
                                              <th colspan="1" class="my-label el-descriptions-item__cell el-descriptions-item__label "></th>
                                              <th colspan="1" style="width: 100px" class="my-label el-descriptions-item__cell el-descriptions-item__label ">自动计算</th>
                                              <th colspan="1" class="my-label el-descriptions-item__cell el-descriptions-item__label "></th>
                                            </tr>
                                            <tr>
                                              <th colspan="2" rowspan="2"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                团队建设
                                              </th>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                有新增海尔业务人员
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                签约目标/人员数量≤1
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                5
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msTdjsA">
                                                  <el-input v-model="f.msTdjsA"  type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="tdjsA">
                                                  <el-input v-model="f.tdjsA" type ="number" min="0" max="5" step="1" oninput="if(value>5)value = 5;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-tdjsA"
                                                            :delflag="false" :showtime="false" :uploadflag="false"  :before-upload="beforeUpload"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                团队能力，产品知识培训获得海尔认可的专业考核
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                人员考核合格率*分值
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                5
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msTdjsB">
                                                  <el-input v-model="f.msTdjsB" type ="textarea" show-word-limit></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="tdjsB">
                                                  <el-input v-model="f.tdjsB" type ="number" min="0" max="5" step="1" oninput="if(value>5)value = 5;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-tdjsB"  :before-upload="beforeUpload"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2" rowspan="2"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                项目信息管理
                                              </th>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                漏斗信息对指标的支撑度；无虚假，无漏单
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                支撑度*分值
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                15
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msXmxxglA">
                                                  <el-input v-model="f.msXmxxglA" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="xmxxglA">
                                                  <el-input v-model="f.xmxxglA" type ="number" min="0" max="15" step="1" oninput="if(value>15)value = 15;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-xmxxglA"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                漏斗信息用户对阵数量的覆盖率
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                覆盖率*分值
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                15
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msXmxxglB">
                                                  <el-input v-model="f.msXmxxglB" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="xmxxglB">
                                                  <el-input v-model="f.xmxxglB" type ="number" min="0" max="15" step="1" oninput="if(value>15)value = 15;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-xmxxglB"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2" rowspan="2"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                市场推广投入
                                              </th>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                市场专项推广会（数量+质量）
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                有推广会议记录
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                15
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msSctgtrA">
                                                  <el-input v-model="f.msSctgtrA" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="sctgtrA">
                                                  <el-input v-model="f.sctgtrA" type ="number" min="0" max="15" step="1" oninput="if(value>15)value = 15;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-sctgtrA"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                分销商会议（数量+质量）
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                有分销商会议记录
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                15
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msSctgtrB">
                                                  <el-input v-model="f.msSctgtrB" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="sctgtrB">
                                                  <el-input v-model="f.sctgtrB" type ="number" min="0" max="15" step="1" oninput="if(value>15)value = 15;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-sctgtrB"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2" rowspan="2"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                用户关系改善
                                              </th>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                薄弱的重点用户关差效果
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                有改善前后效果记录
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                10
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msYhgxgsA">
                                                  <el-input v-model="f.msYhgxgsA" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="yhgxgsA">
                                                  <el-input v-model="f.yhgxgsA" type="number" min="0" max="10" step="1" oninput="if(value>10)value = 10;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-yhgxgsA"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                空白用户关差效果
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                关差前后效果记录
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                10
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msYhgxgsB">
                                                  <el-input v-model="f.msYhgxgsB" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="yhgxgsB">
                                                  <el-input v-model="f.yhgxgsB" type="number" min="0" max="10" step="1" oninput="if(value>10)value = 10;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-yhgxgsB"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>

                                            <tr>
                                              <th colspan="2" rowspan="2"  class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                分销体系建设
                                              </th>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                分销商建设数量及覆盖能力
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                系统查询分销数量记录
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                5
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msFxtxjsA" >
                                                  <el-input v-model="f.msFxtxjsA" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="fxtxjsA" >
                                                  <el-input v-model="f.fxtxjsA" type="number" min="0" max="5" step="1" oninput="if(value>5)value = 5;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-fxtxjsA"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td colspan="2" class="el-descriptions-item__cell el-descriptions-item__content">
                                                单分销商的规模及分销商的满意度回访
                                              </td>
                                              <th colspan="3"   class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">
                                                分销商打分作为经销商对应地市得分
                                              </th>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                5
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="msFxtxjsB" >
                                                  <el-input v-model="f.msFxtxjsB" type ="textarea"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="fxtxjsB" >
                                                  <el-input v-model="f.fxtxjsB" type="number" min="0" max="5" step="1" oninput="if(value>5)value = 5;if(value<0)value = 0"></el-input>
                                                </el-form-item>
                                              </td>
                                              <td colspan="1" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <div label="" class="demo-ruleForm h-formbLine h-formbLine1" style="width: 160px;margin-left:30px">
                                                  <brupload :refid="refid" style="" align="center" reftype="能力胜任-fxtxjsB"
                                                            :delflag="false" :showtime="false" :uploadflag="false"
                                                  >
                                                  </brupload>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">综合分值</th>
                                              <td colspan="9" class="el-descriptions-item__cell el-descriptions-item__content">
                                                ＜60分 区域调整或终止协议 {{"\xa0\xa0\xa0\xa0\xa0\xa0"}}60-80分 整改{{"\xa0\xa0\xa0\xa0\xa0\xa0"}}＞80分 继续合作
                                              </td>
                                            </tr>
                                            <tr>
                                              <th colspan="2" class="my-label el-descriptions-item__cell el-descriptions-item__label ">项目测评得分（40%）</th>
                                              <th colspan="3" class="my-label el-descriptions-item__cell el-descriptions-item__label ">
                                                <el-form-item  prop="projectScore" >
                                                  <template slot-scope="scope">
                                                    <div style="text-align: right;">
                                                      {{projectScore}}
                                                    </div>
                                                  </template>
                                                </el-form-item>
                                              </th>
                                              <th colspan="2" class="my-label el-descriptions-item__cell el-descriptions-item__label ">业绩得分（60%）</th>
                                              <th colspan="1" style="width: 100px" class="my-label el-descriptions-item__cell el-descriptions-item__label ">
                                                <el-form-item  prop="performanceScore" >
                                                  <template slot-scope="scope">
                                                    <div style="text-align: right;">
                                                      {{performanceScore}}
                                                    </div>
                                                  </template>
                                                </el-form-item>
                                              </th>
                                              <th colspan="2" class="my-label el-descriptions-item__cell el-descriptions-item__label ">综合得分</th>
                                              <th colspan="2" style="width: 100px" class="my-label el-descriptions-item__cell el-descriptions-item__label ">{{comprehensiveScore}}</th>
                                            </tr>

                                            <tr>
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">区域经理确认</th>
                                              <th colspan="4" class="el-descriptions-item__cell el-descriptions-item__content"></th>
                                              <th colspan="4" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">大区经理确认</th>
                                              <th colspan="2" class="el-descriptions-item__cell el-descriptions-item__content"></th>
                                            </tr>
                                            <tr>
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">结论</th>
                                              <th colspan="9" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-form-item  prop="conclusion">
                                                  <template slot-scope="scope">
                                                    <div style="text-align: center;">
                                                      {{f.conclusion}}
                                                    </div>
                                                  </template>
                                                </el-form-item>
                                              </th>
                                            </tr>

                                            <tr v-if="showDate">
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">整改时间</th>
                                              <th colspan="3" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <el-date-picker
                                                    style="width: 180px;float: left;margin-left: 50px"
                                                    v-model="f.changeDate"
                                                    type="date"
                                                    value-format="yyyy-MM-dd"
                                                    :picker-options="pickerOptions"
                                                    placeholder="选择到期日">
                                                </el-date-picker>
                                              </th>
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">整改文件</th>
                                              <th colspan="4" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <brupload
                                                    :refid="refid"
                                                    reftype="能力胜任测评-整改文件"
                                                    uploadflag
                                                    delflag
                                                    :showtime="false"
                                                >
                                                </brupload>
                                              </th>
                                            </tr>
                                            <tr v-if="showFile">
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">调整方案</th>
                                              <th colspan="9" class="el-descriptions-item__cell el-descriptions-item__content">
                                                <brupload
                                                    :refid="refid"
                                                    reftype="能力胜任测评-调整方案"
                                                    :uploadflag="false"
                                                    :delflag="false"
                                                    :showtime="false"
                                                >
                                                </brupload>
                                              </th>
                                            </tr>
                                            <tr v-if="guancha">
                                              <th colspan="2" class="my-label-lab el-descriptions-item__cell el-descriptions-item__label is-bordered-label">关差总结</th>
                                              <th colspan="8" class="el-descriptions-item__cell el-descriptions-item__content">{{f.passDifference}}</th>
                                            </tr>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                        </el-form>
                    </div>
                </div>

              <div class="bannerBox2" >
                <div class="h-row h-mrt1">
                  <div class="h-rowIn">
                    <div class="h-rowBox">
                      <div class="h-rowCon">
                        <div class="h-pieceIn2">
                          <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                          <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                            <h1>审核信息</h1>
                          </div>
                          <div class="h-pieceCon2 ">
                            <div class="h-formLine weekplandetail11" style="position: relative;">
                              <el-form :inline="true" :model="f">
                                <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                              style="width: 100%!important;">
                                  <el-input
                                      v-model="f.auditMind2"
                                      placeholder="请输入"></el-input>
                                </el-form-item>
                              </el-form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          <div style="text-align: center;margin-top: 0.3rem">
            <el-button class="h-btn h-bBtn" :class="{'h-bgwhite':this.flag!=='2'&&this.flag!=='5'}"
                       @click="backS">返回
            </el-button>
            <el-button class="h-btn h-bBtn h-bgred"
                       @click="submit('2')">驳回
            </el-button>
            <el-button class="h-btn h-bBtn h-bggreen" @click="submit('1')">通过
            </el-button>
            <el-button class="h-btn h-bBtn" @click="viewpress">
              审批跟踪
            </el-button>

          </div>
          <viewhistory :visible.sync="showhistory" v-if="showhistory"
                       :id="instid"/>
<!--            <div class="h-txtCenter h-mrt60">-->
<!--                <el-button class="h-btn h-bBtn h-bgwhite" @click="backS">返回</el-button>-->
<!--                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="submit">确认提交</el-button>-->

<!--             </div>-->

        </div>
    </div>
</template>

<script>
    import shoudf from '../../../../components/dialog/selectshdf'
    import big from "big.js";
    import agentAbilityService from "../../../../api/loud/agentability/agentAbilityService";

    export default {

        components: {
            shoudf
        },

        data() {

            return {
                showshdfdialog: false,
                selectDailishang: true,
                qudao:[],
                qudaos:'',
                qweekList :[],
                //承接部门
                JobGroup: [],
                //回复人
                PointUser: [],
                refid:null,
                j:{
                    jobGroup: null,
                },
                showDate:false,
                showFile:false,
                guancha:false,
                showhistory:null,
                instid:null,
                taskid:null,
                //表单
                f:{
                    id:null,
                    agentCode:null,//经销商编码
                    agentName:null,//经销商名称
                    evaluationDate:null,//测评日期
                    areaName:null,//地区
                    areaCode:null,//地区编码
                    legal:null,//法人代表
                    againstAreaActualCount:null,//对阵地市实际（个数）
                    againstUserActualCount:null,//对阵用户实际（个数）
                    againstAreaTargetCount:null,//对阵地市目标（个数）
                    againstUserTargetlCount:null,//对阵用户目标（个数）
                    yearActual:null,//年实际
                    yearTargetl:null,//年目标
                    quarterActual:null,//季度实际
                    quarterTargetl:null,//季度目标
                    yearLx:null,//年履约率
                    quarterLx:null,//季度履约率
                    tdjsA:null,//有新增海尔业务人员
                    tdjsB:null,//团队能力，产品知识培训获得海尔认可的专业考核
                    xmxxglA:null,//漏斗信息对指标的支撑度；无虚假，无漏单
                    xmxxglB:null,//漏斗信息用户对阵数量的覆盖率
                    sctgtrA:null,//市场专项推广会（数量+质量）
                    sctgtrB:null,//分销商会议（数量+质量）
                    yhgxgsA:null,//薄弱的重点用户关差效果
                    yhgxgsB:null,//空白用户关差效果
                    fxtxjsA:null,//分销商建设数量及覆盖能力
                    fxtxjsB:null,//单分销商的规模及分销商的满意度回访
                    conclusion:null,//评价结论＜60分 区域调整或终止协议60-80分 整改＞80分 继续合作
                    projectScore:null,//项目测评得分（40%）
                    performanceScore:null,//业绩得分（60%）
                    evaluateSummarize:null,//评价总结
                    daquConfirm:null,//大区确认
                    quyuConfirm:null,//区域确认
                    passDifference:null,//关差总结
                    msTdjsA :null,//团队能力，产品知识培训获得海尔认可的专业考核描述
                    msTdjsB :null,//团队能力，产品知识培训获得海尔认可的专业考核描述
                    msXmxxglA:null,//漏斗信息对指标的支撑度；无虚假，无漏单描述
                    msXmxxglB:null,//漏斗信息用户对阵数量的覆盖率描述
                    msSctgtrA:null,//市场专项推广会（数量+质量）描述
                    msSctgtrB:null,//分销商会议（数量+质量）描述
                    msYhgxgsA:null,//薄弱的重点用户关差效果描述
                    msYhgxgsB:null,//空白用户关差效果 描述
                    msFxtxjsA:null,//分销商建设数量及覆盖能力 描述
                    msFxtxjsB:null,//单分销商的规模及分销商的满意度回访 描述
                    comprehensiveScore:null,//综合得分
                    changeDate:null,//整改到期日
                    instid:null,
                    auditMind2:null,
                    fileid:null,
                },
                rules: {
                  msTdjsA: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  tdjsA: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msTdjsB: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  tdjsB: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msXmxxglA: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  xmxxglA: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msXmxxglB: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  xmxxglB: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msSctgtrA: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  sctgtrA: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msSctgtrB: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  sctgtrB: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msYhgxgsA: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  yhgxgsA: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msYhgxgsB: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  yhgxgsB: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msFxtxjsA: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  fxtxjsA: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  msFxtxjsB: [{required: true, message: '请填写实际描述', trigger: 'blur'}],
                  fxtxjsB: [{required: true, message: '请填写得分', trigger: 'blur'}],

                  changeDate: [{required: true, message: '请选择时间', trigger: 'change'}],

                },

            }
        },

        created() {
          this.f.instid =  this.$route.query.instid;
          this.instid =  this.$route.query.instid;
          this.taskid =  this.$route.query.taskid;
          console.log("instid",this.$route.query.instid)
          this.query(this.$route.query.instid);
        },
        computed : {
          projectScore: function () {
            var num = new big(this.f.tdjsA||0).plus(this.f.tdjsB||0).plus(this.f.xmxxglA||0).plus(this.f.xmxxglB||0)
                .plus(this.f.sctgtrA||0).plus(this.f.sctgtrB||0).plus(this.f.yhgxgsA||0).plus(this.f.yhgxgsB||0)
                .plus(this.f.fxtxjsA||0).plus(this.f.fxtxjsB||0).toString()
            return parseFloat(num*0.4).toFixed(2);
          },
          performanceScore: function () {
            var num = 0;
            if(this.f.quarterActual != 0 && this.f.quarterActual != null){
              num = this.f.quarterActual/this.f.quarterTargetl;
            }
            if(num > 1){
              num = 1;
            }
            num = num*100;
            return parseFloat(num*0.6).toFixed(2);
          },
          comprehensiveScore: function () {
            var num = new big(this.f.tdjsA||0).plus(this.f.tdjsB||0).plus(this.f.xmxxglA||0).plus(this.f.xmxxglB||0)
                .plus(this.f.sctgtrA||0).plus(this.f.sctgtrB||0).plus(this.f.yhgxgsA||0).plus(this.f.yhgxgsB||0)
                .plus(this.f.fxtxjsA||0).plus(this.f.fxtxjsB||0).toString()
             var s = parseFloat(num*0.4).toFixed(2);
            var num1 = 0;
            if(this.f.quarterActual != 0 && this.f.quarterActual != null){
              num1 = this.f.quarterActual/this.f.quarterTargetl*100;
            }
            if(num1 > 100){
              num1 = 100;
            }
            var s1 = parseFloat(num1*0.6).toFixed(2);
            var number = parseFloat(new big(s||0).plus(s1||0).toString());
            if(number>80){
              this.f.conclusion = "继续合作"
              this.showDate = false;
              this.showFile = false;
              console.log("继续合作");
            }else if(number>60&&number<80){
              this.f.conclusion = "整改"
              this.showDate = true;
              this.showFile = false;
              console.log("整改");
            }else if(number<60){
              this.f.conclusion = "区域调整或终止协议"
              this.showDate = false;
              this.showFile = true;
              console.log("区域调整或终止协议");
            }
            return number;
          },
        },


        methods: {

            //返回
            backS() {
              this.$router.go(-1);
            },
          //
            query(instid) {
              agentAbilityService.selectByInstId(instid).then(rd => {
                console.log("rd",rd)
                this.f= rd.obj;
                this.refid = this.f.fileid;
              })
            },

            getQudao(value){
                var jsonObj = value
                var jStr = '';
                for(var item in jsonObj){
                    jStr += jsonObj[item]+",";
                }
                this.channels = jStr.substring(0, jStr.lastIndexOf(','))
             },
            viewpress() {
              this.showhistory = true;
            },
            //提交
            submit(num) {
                let query ={
                  aaa:num,
                  taskid:this.taskid,
                  auditMind2:this.f.auditMind2,
                  id:this.f.id,
                  areaCode:this.f.areaCode,
                };
                //通过
                  agentAbilityService.approvalPass(query).then(rd=>{
                    this.$msg.alerts("提交成功！", () => {
                      //刷新右上角的代办个数
                      this.$store.dispatch("searchTasktotal")
                      //跳转回系统的代办列表
                      this.$router.go(-1);
                    })
                  })
            },

        }

    }


</script>
<style scoped lang="scss">
    ::v-deep .meeting-table  th ,td {

         text-align: center!important;
         border: 1px solid #303133!important;
         vertical-align:middle;

     }
    ::v-deep .my-label {
         background: #fff2e5!important;

     }
    ::v-deep .my-label-lab {
         background: #E8F5F8!important;

     }
    ::v-deep.ljjtablepaddings1 .h-tableInput .el-input__icon{
         line-height: 0.25rem;
     }

    ::v-deep .el-form-item {
         margin-bottom: 0 !important;
     }
</style>